import { DataGrid, GridColDef } from "@mui/x-data-grid";
import SectionCard from "../../../components/SectionCard";
import { useDashboard } from "../../../context/HDBDashboardContext";
import styles from "./index.module.scss";
import { colorizeMahatriaInfinitheism } from "../../../common/components/ColorizeMahatriaInfinitheism";
import { setSelectedKpiTab } from "../../../reducers/ProgramReducer";
import { useDispatch } from "react-redux";

const DetailedTable = ({ detailedData }) => {
  const { columnDefinition, values, displayName } = detailedData || {};
  const { updateFilters } = useDashboard()

  if (!columnDefinition || !values) return null;

  const columns: GridColDef[] = columnDefinition.map((col) => ({
    field: col.key,
    headerName: col.displayName,
    flex: 1,
        ...(col.key === "hdbsMsds"
    ? {
        renderCell: (params) => colorizeMahatriaInfinitheism(params.value),
      }
    : {}), 
  }));

  const rows = values.map((row, index) => ({
    id: index,
    ...row,
  }));
  const dispatch = useDispatch();

  const handleCellClick = (params) => {
    const {field, row} = params;
    const filter = row.filters?.[field];
    if (filter) {
          updateFilters(filter);

          dispatch(
            setSelectedKpiTab({
              kpiFilter: filter?.kpiFilter,
              kpiCategory: filter?.kpiCategory,
            }),
          );
        }
  };

  return (
    <SectionCard title={displayName} customClass={styles.detailedTableCard}>
      <div className={styles.tableWrapper}>
        <DataGrid
          rows={rows}
          columns={columns.map((col)=>({
                ...col,
                headerName: colorizeMahatriaInfinitheism(col.headerName),
              }))}
          autoHeight
          onCellClick={handleCellClick}
          hideFooter
          sx={{
            border: "none",
            "& .MuiDataGrid-columnHeaders": {
              borderBottom: "none",
              color: "#888888", // 👈 header text color
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              cursor: "pointer",
            },

          }}
        />
      </div>
    </SectionCard>
  );
};

export default DetailedTable;
